import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../config";
import cogoToast from "cogo-toast";

// ================================================================= GET ALL TRADABLE COINS

export const getAllCoins = createAsyncThunk(
  "getAllCoins",
  async (values, { rejectWithValue, dispatch, getState }) => {
    const id = getState().auth.user.user_id;
    try {
      const res = await axios.get(`${baseUrl}/coin/type?userId=${id}`, {
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": getState().auth.token.toString(),
        },
      });
      if (res.status === 200) {
        console.log(res);
        return res.data;
      }
    } catch (error) {
      if (error.response.status === 401) {
        dispatch({ type: "auth/Logout" });
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.response);
      }
    }
  }
); 

// ================================================================= GET ALL COIN BY ID

export const getCoinById = createAsyncThunk(
  "getCoinById",
  async (values, { rejectWithValue, dispatch, getState }) => {
   
    try {
      const res = await axios.get(`${baseUrl}/coin/rate?coinTypeId=${values.coinTypeId}`, {
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": getState().auth.token.toString(),
        },
      });
      if (res.status === 200) {
        console.log(res);
        return res.data;
      }
    } catch (error) {
      if (error.response.status === 401) {
        dispatch({ type: "auth/Logout" });
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.response);
      }
    }
  }
);

// ================================================================= TRADE NEW COIN

export const tradeNewCoin = createAsyncThunk(
  "tradeNewCoin",
  async (values, { rejectWithValue, dispatch, getState }) => {
    const id = getState().auth.user.user_id;
    try {
      const res = await axios.post(
        `${baseUrl}/coin/sell/${id}`,
        {
          coinTypeId: values.coinTypeId,
          coinNetworkId: values.coinNetworkId,
          amount: values.amount,
          rate: values.coinTypeRate,
          payoutAmount: values.payoutAmount,
          creditWalletId: values.creditWalletId,
          sellerRemarks: "",
          coinAmount: parseFloat(values.coinAmount).toFixed(6)
        },
        {
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": getState().auth.token.toString(),
          },
        }
      );
      if (res.status === 200 || res.status === 201) {
        console.log(res);
        cogoToast.success("Trade Created Successfully");
        return res.data;
      }
    } catch (error) {
      if (error.response.status === 401) {
        cogoToast.error("Wallet Not created");
        // dispatch({ type: "auth/Logout" });
        return rejectWithValue(error.response);
      } else if (error.response.status === 401) {
        dispatch({ type: "auth/logout" });
        return rejectWithValue(error.response);
      } else if (error.response.status === 410) {
        cogoToast.error("Error generating barCode, please try again, Thank you!")
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.response);
      }
    }
  }
);


// ================================================================= FETCH CRYPTO TRANSACTIONS

export const fetchCryptoTransactions = createAsyncThunk(
  "fetchCryptoTransactions",
  async (values, { rejectWithValue, dispatch, getState }) => {
    const id = getState().auth.user.user_id;
    try {
      const res = await axios.get(
        `${baseUrl}/coin/inward/${id}`,
         {
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": getState().auth.token.toString(),
          },
        }
      );
      if (res.status === 200 || res.status === 201) {
        console.log(res);
        return res.data;
      }
    } catch (error) {
      if (error.response.status === 401) {
        cogoToast.error("Wallet Not created");
        // dispatch({ type: "auth/Logout" });
        return rejectWithValue(error.response);
      } else if (error.response.status === 401) {
        dispatch({ type: "auth/logout" });
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.response);
      }
    }
  }
);

// ================================================================= GENERATE SWAP QUOTATION

export const generateSwapQuotation = createAsyncThunk(
  "generateSwapQuotation",
  async (values, { rejectWithValue, dispatch, getState }) => {
    const id = getState().auth.user.user_id;
    try {
      const res = await axios.post(
        `${baseUrl}/coin/wallet/crypto/quotation/${id}`,
        {
          from_currency: values.from_currency,
          to_currency: values.to_currency,
          from_amount: values.from_amount,
          quidaxUserId: values.quidaxUserId,
          network: values?.network || null,
          transaction_type: values.transaction_type
        },
        {
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": getState().auth.token.toString(),
          },
        }
      );
      if (res.status === 200 || res.status === 201) {
        console.log("Swap quotation:", res);
        return res.data;
      }
    } catch (error) {
      if (error.response.status === 401) {
        cogoToast.error("Unauthorized access");
        dispatch({ type: "auth/Logout" });
        return rejectWithValue(error.response);
      } else if (error.response.status === 400) {
        cogoToast.error("Invalid swap parameters");
        return rejectWithValue(error.response);
      } else if (error.response.status === 404) {
        cogoToast.error("Swap quotation not available");
        return rejectWithValue(error.response);
      } else {
        cogoToast.error("Failed to generate swap quotation");
        return rejectWithValue(error.response);
      }
    }
  }
);

// ================================================================= CREATE SWAP TRANSACTION
export const createSwapTransaction = createAsyncThunk(
  "createSwapTransaction",
  async (values, { rejectWithValue, dispatch, getState }) => {
    const userId = getState().auth.user.user_id;
    try {
      const res = await axios.post(
        `${baseUrl}/coin/wallet/swap/create/${userId}`,
        {
          from_currency: values.from_currency,
          to_currency: values.to_currency,
          from_amount: values.from_amount,
          quidaxUserId: values.quidaxUserId
        },
        {
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": getState().auth.token.toString(),
          },
        }
      );
      if (res.status === 200 || res.status === 201) {
        return res.data;
      }
    } catch (error) {
      if (error.response.status === 401) {
        cogoToast.error("Unauthorized access");
        dispatch({ type: "auth/Logout" });
        return rejectWithValue(error.response);
      } else if (error.response.status === 400) {
        cogoToast.error("Invalid swap parameters");
        return rejectWithValue(error.response);
      } else if (error.response.status === 404) {
        cogoToast.error("Swap service not available");
        return rejectWithValue(error.response);
      } else if (error.response.status === 409) {
        cogoToast.error("Insufficient balance for swap");
        return rejectWithValue(error.response);
      } else if (error.response.status === 422) {
        cogoToast.error("Invalid swap amount or currency");
        return rejectWithValue(error.response);
      } else {
        cogoToast.error("Failed to create swap transaction");
        return rejectWithValue(error.response);
      }
    }
  }
);

// ================================================================= TRADE CRYPTO TO FIAT
export const tradeCryptoToFiat = createAsyncThunk(
  "tradeCryptoToFiat",
  async (values, { rejectWithValue, dispatch, getState }) => {
    const userId = getState().auth.user.user_id;
    try {
      const res = await axios.post(
        `${baseUrl}/coin/wallet/crypto/fiat/${userId}`,
        {
          coinTypeId: values.coinTypeId,
          amount: values.amount,
          rate: values.rate,
          payoutAmount: values.payoutAmount,
          creditWalletId: values.creditWalletId,
          coinAmount: values.coinAmount,
          sellerRemarks: values.sellerRemarks || ""
        },
        {
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": getState().auth.token.toString(),
          },
        }
      );
      if (res.status === 200 || res.status === 201) {
        return res.data;
      }
    } catch (error) {
      if (error.response.status === 401) {
        cogoToast.error("Unauthorized access");
        dispatch({ type: "auth/Logout" });
        return rejectWithValue(error.response);
      } else if (error.response.status === 400) {
        cogoToast.error("Invalid trade parameters");
        return rejectWithValue(error.response);
      } else if (error.response.status === 404) {
        cogoToast.error("Trade service not available");
        return rejectWithValue(error.response);
      } else if (error.response.status === 409) {
        cogoToast.error("Insufficient balance for trade");
        return rejectWithValue(error.response);
      } else if (error.response.status === 422) {
        cogoToast.error("Invalid trade amount or currency");
        return rejectWithValue(error.response);
      } else {
        cogoToast.error("Failed to complete crypto to fiat trade");
        return rejectWithValue(error.response);
      }
    }
  }
);


// ================================================================= FIAT TO CRYPTO
export const fiatToCrypto = createAsyncThunk(
  "fiatToCrypto",
  async (values, { rejectWithValue, dispatch, getState }) => {
    const userId = getState().auth.user.user_id;
    try {
      const res = await axios.post(
        `${baseUrl}/coin/wallet/fiat/crypto/${userId}`,
        {
          coinTypeId: values.coinTypeId,
          debitWalletId: values.debitWalletId,
          amountFiat: values.amountFiat
        },
        {
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": getState().auth.token.toString(),
          },
        }
      );
      if (res.status === 200 || res.status === 201) {
        return res.data;
      }
    } catch (error) {
      if (error.response.status === 401) {
        cogoToast.error("Unauthorized access");
        dispatch({ type: "auth/Logout" });
        return rejectWithValue(error.response);
      } else if (error.response.status === 400) {
        cogoToast.error("Invalid fiat to crypto parameters");
        return rejectWithValue(error.response);
      } else if (error.response.status === 404) {
        cogoToast.error("Fiat to crypto service not available");
        return rejectWithValue(error.response);
      } else if (error.response.status === 409) {
        cogoToast.error("Insufficient fiat balance");
        return rejectWithValue(error.response);
      } else if (error.response.status === 422) {
        cogoToast.error("Invalid fiat amount or coin");
        return rejectWithValue(error.response);
      } else {
        cogoToast.error("Failed to complete fiat to crypto trade");
        return rejectWithValue(error.response);
      }
    }
  }
);

// ================================================================= CRYPTO WITHDRAWAL
export const cryptoWithdrawal = createAsyncThunk(
  "cryptoWithdrawal",
  async (values, { rejectWithValue, dispatch, getState }) => {
    const userId = getState().auth.user.user_id;
    try {
      const res = await axios.post(
        `${baseUrl}/coin/wallet/crypto/withdrawal/${userId}`,
        {
          coinTypeId: values.coinTypeId,
          amount: values.amount,
          coinNetwork: values.coinNetwork,
          walletAddress: values.walletAddress,
          transactionPin: values.transactionPin
        },
        {
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": getState().auth.token.toString(),
          },
        }
      );
      if (res.status === 200 || res.status === 201) {
        cogoToast.success("Withdrawal request submitted!");
        return res.data;
      }
    } catch (error) {
      if (error.response.status === 401) {
        cogoToast.error("Unauthorized access");
        dispatch({ type: "auth/Logout" });
        return rejectWithValue(error.response);
      } else if (error.response.status === 400) {
        cogoToast.error(`${error.response.data.message || "Invalid withdrawal parameters"}`);
        return rejectWithValue(error.response);
      } else if (error.response.status === 404) {
        cogoToast.error("Withdrawal service not available");
        return rejectWithValue(error.response);
      } else if (error.response.status === 409) {
        cogoToast.error("Insufficient balance for withdrawal");
        return rejectWithValue(error.response);
      } else if (error.response.status === 422) {
        cogoToast.error("Invalid withdrawal amount or address");
        return rejectWithValue(error.response);
      } else {
        cogoToast.error(`${error.response.data.message || "Failed to process crypto withdrawal"}`);
        return rejectWithValue(error.response);
      }
    }
  }
);

// ================================================================= CRYPTO WITHDRAWAL BY TAG
export const cryptoWithdrawalByTag = createAsyncThunk(
  "cryptoWithdrawalByTag",
  async (values, { rejectWithValue, dispatch, getState }) => {
    const userId = getState().auth.user.user_id;
    try {
      const res = await axios.post(
        `${baseUrl}/coin/wallet/tag/crypto/withdrawal/${userId}`,
        {
          coinTypeId: values.coinTypeId,
          amount: values.amount,
          recipientTag: values.recipientTag,
          transactionPin: values.transactionPin
        },
        {
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": getState().auth.token.toString(),
          },
        }
      );
      if (res.status === 200 || res.status === 201) {
        cogoToast.success("Withdrawal to tag submitted!");
        return res.data;
      }
    } catch (error) {
      if (error.response.status === 401) {
        cogoToast.error("Unauthorized access");
        dispatch({ type: "auth/Logout" });
        return rejectWithValue(error.response);
      } else if (error.response.status === 400) {
        cogoToast.error(`${error.response.data.message || "Invalid withdrawal parameters"}`);
        return rejectWithValue(error.response);
      } else if (error.response.status === 404) {
        cogoToast.error("Withdrawal service not available");
        return rejectWithValue(error.response);
      } else if (error.response.status === 409) {
        cogoToast.error("Insufficient balance for withdrawal");
        return rejectWithValue(error.response);
      } else if (error.response.status === 422) {
        cogoToast.error("Invalid withdrawal amount or tag");
        return rejectWithValue(error.response);
      } else {
        cogoToast.error(`${error.response.data.message || "Failed to process crypto withdrawal by tag"}`);
        return rejectWithValue(error.response);
      }
    }
  }
);

// ================================================================= TRADE ORDER LIMIT
export const tradeOrderLimit = createAsyncThunk(
  "tradeOrderLimit",
  async (values, { rejectWithValue, dispatch, getState }) => {
    const userId = getState().auth.user.user_id;
    try {
      const res = await axios.post(
        `${baseUrl}/coin/wallet/crypto/limit/order/${userId}`,
        {
          coinTypeId: values.coinTypeId,
          price: values.price,
          totalToDebit: values.totalToDebit,
          side: values.side
        },
        {
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": getState().auth.token.toString(),
          },
        }
      );
      if (res.status === 200 || res.status === 201) {
        cogoToast.success("Limit order placed successfully!");
        return res.data;
      }
    } catch (error) {
      console.log("Limit order error:", error.response.data);
      if (error.response.status === 401) {
        cogoToast.error("Unauthorized access");
        dispatch({ type: "auth/Logout" });
        return rejectWithValue(error.response);
      } else if (error.response.status === 400) {
        cogoToast.error(`${error.response.data.message || "Bad Request"}`);
        return rejectWithValue(`${error.response.data.message || "Bad Request"}`);
      } else if (error.response.status === 404) {
        cogoToast.error(`${error.response.data.message || "Limit order service not available"}`);
        return rejectWithValue(`${error.response.data.message || "Limit order service not available"}`);
      } else if (error.response.status === 409) {
        cogoToast.error(`${error.response.data.message || "Insufficient balance for limit order"}`);
        return rejectWithValue(`${error.response.data.message || "Insufficient balance for limit order"}`);
      } else if (error.response.status === 422) {
        cogoToast.error(`${error.response.data.message || "Invalid order amount or price"}`);
        return rejectWithValue(`${error.response.data.message || "Invalid order amount or price"}`);
      } else {
        cogoToast.error(`${error.response.data.message || "Failed to place limit order"}`);
        return rejectWithValue(`${error.response.data.message || "Failed to place limit order"}`);
      }
    }
  }
);

// ================================================================= CANCEL ORDER LIMIT
export const cancelOrderLimit = createAsyncThunk(
  "cancelOrderLimit",
  async (values, { rejectWithValue, dispatch, getState }) => {
    const userId = getState().auth.user.user_id;
    try {
      const res = await axios.post(
        `${baseUrl}/coin/wallet/crypto/cancel/limit-order/${userId}`,
        {
          orderId: values.orderId
        },
        {
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": getState().auth.token.toString(),
          },
        }
      );
      if (res.status === 200 || res.status === 201) {
        cogoToast.success("Limit order cancelled successfully!");
        return res.data;
      }
    } catch (error) {
      if (error.response.status === 401) {
        cogoToast.error("Unauthorized access");
        dispatch({ type: "auth/Logout" });
        return rejectWithValue(error.response);
      } else if (error.response.status === 400) {
        cogoToast.error(`${error.response.data.message || "Bad Request"}`);
        return rejectWithValue(`${error.response.data.message || "Bad Request"}`);
      } else if (error.response.status === 404) {
        cogoToast.error(`${error.response.data.message || "Order not found"}`);
        return rejectWithValue(`${error.response.data.message || "Order not found"}`);
      } else if (error.response.status === 409) {
        cogoToast.error(`${error.response.data.message || "Cannot cancel this order"}`);
        return rejectWithValue(`${error.response.data.message || "Cannot cancel this order"}`);
      } else {
        cogoToast.error(`${error.response.data.message || "Failed to cancel limit order"}`);
        return rejectWithValue(`${error.response.data.message || "Failed to cancel limit order"}`);
      }
    }
  }
);

// ================================================================= GET USER CRYPTO TRANSACTIONS
export const getUserCryptoTransactions = createAsyncThunk(
  "getUserCryptoTransactions",
  async (values = {}, { rejectWithValue, dispatch, getState }) => {
    const userId = getState().auth.user.user_id;
    try {
      const params = new URLSearchParams();
      if (values.mode) params.append("mode", values.mode);
      if (values.coinType) params.append("coinType", values.coinType);
      if (values.status) params.append("status", values.status);
      if (typeof values.page !== "undefined") params.append("page", values.page);
      if (typeof values.per_page !== "undefined") params.append("per_page", values.per_page);

      const res = await axios.get(
        `${baseUrl}/coin/transactions/${userId}?${params.toString()}`,
        {
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": getState().auth.token.toString(),
          },
        }
      );

      if (res.status === 200 || res.status === 201) {
        return res.data;
      }

      return rejectWithValue(res);
    } catch (error) {
      if (error?.response?.status === 401) {
        cogoToast.error("Unauthorized access");
        dispatch({ type: "auth/Logout" });
        return rejectWithValue(error.response);
      } else if (error?.response?.data?.message) {
        cogoToast.error(error.response.data.message);
        return rejectWithValue(error.response);
      } else {
        cogoToast.error("Failed to fetch transactions");
        return rejectWithValue(error.response || error);
      }
    }
  }
);

// ================================================================= GET CHART DATA
export const getChartData = createAsyncThunk(
  "getChartData",
  async ({ coinTypeId, period = 1, minutes = 15, limit = 1000 }, { rejectWithValue, getState, dispatch }) => {
    try {
      const token = getState().auth.token;
      const res = await axios.get(
        `${baseUrl}/coin/chart/data/${coinTypeId}?period=${period}&minutes=${minutes}&limit=${limit}`,
        { headers: { "Content-Type": "application/json", "x-auth-token": token?.toString() } }
      );
      if (res.status === 200) return res.data;
      return rejectWithValue(res);
    } catch (error) {
      if (error?.response?.status === 401) {
        dispatch({ type: "auth/Logout" });
        return rejectWithValue(error.response);
      }
      return rejectWithValue(error.response || error);
    }
  }
);